/**
 * @file Offboarding.jsx
 *
 * @author - Team E (Meeramol Mathew, Krishnapriya N, Anju Sebastian)
 * @sprint - B2W-Sprint-1
 * @description -
 * This component manages the offboarding process, including creating, updating,
 * viewing, and deleting records. Data is stored in local storage, and notifications are displayed upon actions.
 *
 */
 
import React, { useState, useEffect } from "react";
import { useParams } from 'react-router-dom';
import { Button, notification } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import CreateEditForm from "../../components/Offboarding/CreateEditForm";
import ViewForm from "../../components/Offboarding/ViewForm";
import ListView from "../../components/Offboarding/ListView";
import Layout from "../../component/Layout";
import axios from 'axios';
 import store from "../../redux/store";
 
/**
 * Offboarding Component
 *
 * @component
 * @returns {JSX.Element} The rendered Offboarding component.
 */
const Offboarding = () => {
 
  const [visible, setVisible] = useState(false);  // Manage modal visibility
  const [data, setData] = useState([]);
  const [isViewModalVisible, setIsViewModalVisible] = useState(false); // Manage ViewForm modal
  const [selectedRecord, setSelectedRecord] = useState(null); // Store selected record for ViewForm
  const [filteredData, setFilteredData] = useState([]);
  const { userToken } = useParams();


 //Get userId(userToken) from url
  const storedUserToken=userToken;
  const token = store.getState().auth.token;
      if (!token) {
        throw new Error("No token found. User not authenticated.");
      }
  const fetchData = async () => {
    try {
      const response = await axios.get(`http://localhost:8080/api/offboarding/by-user/${storedUserToken}`, {
        headers: {
          'Authorization': `Bearer ${token}`  // Replace `token` with the actual token you want to pass
        }
      });
      setFilteredData(response.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
 
  // Fetch data when component mounts
  useEffect(() => {
    fetchData();
  }, [storedUserToken]);
 
 
  /**
   * Effect to load stored form data from local storage when component mounts.
   */
  useEffect(() => {
    // Load data from local storage on component mount
    const storedData = localStorage.getItem('formData');
    console.log(storedData);
    if (storedData) {
      const parsedData = JSON.parse(storedData)
        .map(item => ({
          ...item
        }));
      setData(parsedData);
    }
  }, []);
 
 
  /**
   * Handles file download functionality.
   * @param {Object} file - The file object to be downloaded.
   */
  const onDownload = async(record,file) => {
    try{
      const response = await axios.get(`http://localhost:8080/api/offboarding/get-filedetails/${record.offboardingId}/${file.name}`, {
        responseType: 'json', // Important to handle binary data
        headers: {
          'Authorization': `Bearer ${token}`  // Replace `token` with the actual token you want to pass
        }
      });

      console.log("Downloading:", response.data);
     // console.log(URL.createObjectURL(response.data.originFileObj));
    const url = URL.createObjectURL(new Blob([response.data.fileData], { type: response.headers['content-type'] }));
    const a = document.createElement("a");
    a.href = url;
    a.download = response.data.name;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
    // Show success notification
    notification.success({
      message: "Download Complete",
      description: `${file.name} downloaded successfully!`,
      placement: "topRight",
      btn: (
        <Button type="primary" size="small" onClick={() => notification.destroy()}>
          OK
        </Button>
      ),
    });
    }
    catch(error){
      console.log(error);
      notification.error({
        message: error.response.data.message,
        description: `${file.name} downloaded error!`,
        placement: "topRight",
        btn: (
          <Button type="primary" size="small" onClick={() => notification.destroy()}>
            OK
          </Button>
        ),
      });
    }
   
 
  }
 
  /**
   * Handles the creation of a new record.
   * @param {Object} values - Form values submitted by the user.
   */
  const onCreate = async (values) => {
    console.log("Form submitted with values:", values);
   
    const newData = [...data];
    const formData = new FormData();
 
  if (values.attachment && values.attachment.length > 0) {
    values.attachment.forEach(file => {
     // formData.append('files', file.originFileObj);
     const userId = storedUserToken;  
     const fileExtension = file.originFileObj.name.split('.').pop();
    
     let newFileName = file.originFileObj.name;
      if (!newFileName.includes(userId)){
         newFileName = `${userId}_${file.originFileObj.name}`;
      }
 
     // Create a new File object with the updated name
     const renamedFile = new File([file.originFileObj], newFileName, { type: file.originFileObj.type });
 
     // Append the renamed file to formData
     formData.append('files', renamedFile);
    });
  }
  delete values.item;
    delete values.key;
    delete values.attachment;
    const currentData ={
      ...values,
      userToken: storedUserToken
    }
  formData.append('offboardingData', JSON.stringify(currentData));
        try {
          const response = await axios.post('http://localhost:8080/api/offboarding/create', formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
              'Authorization': `Bearer ${token}` 
            },
          });
 
          // Handle successful response
        //  setResponseData(response.data);
          console.log('API Response:', response);
           // Show success message
    notification.success({
      message: "Success",
      description: "Item added successfully!",
      placement: "topRight", // Adjust position (options: 'topLeft', 'topRight', 'bottomLeft', 'bottomRight')
      btn: (
        <Button type="primary" size="small" onClick={() => notification.destroy()}>
          OK
        </Button>
      ),
    });
           fetchData();
      } catch (err) {
          // Handle error
        //  setError('Error: Unable to make API call');
         console.log("Error-------------------"+err);
           // Show Error message
    notification.error({
      message: "Error",
      description:err.response.data.message,
      placement: "topRight", // Adjust position (options: 'topLeft', 'topRight', 'bottomLeft', 'bottomRight')
      btn: (
        <Button type="primary" size="small" onClick={() => notification.destroy()}>
          OK
        </Button>
      ),
    });
      }
 
   
    setData(newData);  // Update state with new data
    //localStorage.setItem('formData', JSON.stringify(newData));  // Save data to local storage
    setVisible(false);  // Close modal after submitting form
    //console.log("Form submitted with values:", data);
 
   
 
  };
 
  /**
   * Handles the deletion of a record.
   * @param {Object} record - The record to be deleted.
   */
 
  const onDelete = async (record) => {
    try {
      // Send DELETE request to the backend
      //const response = await axios.delete(`http://localhost:8080/api/offboarding/${record.offboardingId}`);

      const response = await axios.delete(`http://localhost:8080/api/offboarding/delete/${record.offboardingId}`, {
        headers: {
          'Authorization': `Bearer ${token}`  // Replace `token` with the actual token you want to pass
        }
      });
      fetchData();
      // Show success notification
      notification.success({
        message: response.data,
        description: "Record deleted successfully!",
        placement: "topRight",
        btn: (
          <Button type="primary" size="small" onClick={() => notification.destroy()}>
            OK
          </Button>
        ),
      });
    } catch (error) {
      console.error("Error deleting record:", error);
      notification.error({
        message: error.response.data.message,
        description: "Failed to delete the record. Please try again later.",
        placement: "topRight",
      });
    }
  };
 
  /**
   * Handles opening the view modal for a record.
   * @param {Object} record - The record to be viewed.
   */
  const handleView = (record) => {
    setSelectedRecord(record);
    setIsViewModalVisible(true);
  };
 
  /**
   * Handles opening the edit modal for a record.
   * @param {Object} record - The record to be edited.
   */
  const onEdit = async(record) => {
    console.log("In Offboarding", record);
    try{
      const response = await axios.get(`http://localhost:8080/api/offboarding/get-details/${record.offboardingId}`, {
        responseType: 'json', // Important to handle binary data
        headers: {
          'Authorization': `Bearer ${token}`  // Replace `token` with the actual token you want to pass
        }
      });
 console.log("Editing:", response.data);
      setSelectedRecord(response.data);
    setVisible(true);
    }
    catch(error){
      console.error("Error editing record:", error);
      notification.error({
        message: error.response.data.message,
        description: "Failed to edit the record. Please refresh the page.",
        placement: "topRight",
      });
    }
 
   
  };
 
 
  const onUpdate = async (values,selectedRecord) => {
    console.log("Form submitted with values:", values);
    const updateData ={
      ...values,
      userToken: storedUserToken
    }
    
    const formData = new FormData();
 
  if (values.attachment && values.attachment.length > 0) {
    values.attachment.forEach(file => {
      console.log("originFileObj",file.originFileObj);
      if(file.originFileObj==null){
        // Convert Base64 string to a Blob
        const byteCharacters = atob(file.base64);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: file.type });

        // Create a new File object
        const newFile = new File([blob], file.name, { type: file.type });
        file.originFileObj = newFile; // Set the originFileObj field
     // const newFile = new File([file], file.name, { type: file.type });
     // newFile.originFileObj = file;
      console.log("new File",file);
      
      }

      const userId = storedUserToken;  
      const fileExtension = file.originFileObj.name.split('.').pop();
      let newFileName = file.originFileObj.name;
      if (!newFileName.includes(userId)){
         newFileName = `${userId}_${file.originFileObj.name}`;
      }
      // Create a new File object with the updated name
      const renamedFile = new File([file.originFileObj], newFileName, { type: file.originFileObj.type });
  
      // Append the renamed file to formData
      formData.append('files', renamedFile);




      //formData.append('files', file.originFileObj);
    });
  }
  delete values.item;
    delete values.key;
    delete values.attachment;
   
  formData.append('offboardingData', JSON.stringify(updateData));
  console.log("FormData:", formData);
    try {
      // Send PUT request to backend
       await axios.put(`http://localhost:8080/api/offboarding/update/${selectedRecord.offboardingId}`,formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization': `Bearer ${token}` 
         },
      });
     
        // Show success notification
        notification.success({
          message: "Update Successful",
          description: "Record has been updated successfully!",
          placement: "topRight",
          btn: (
            <Button type="primary" size="small" onClick={() => notification.destroy()}>
              OK
            </Button>
          ),
        });
       
        setSelectedRecord(null); // Reset selected record
        setVisible(false); // Close modal
        fetchData();
     
    } catch (error) {
      console.error("Error updating record:", error);
      notification.error({
        message: "Update Error",
        description: error.response.data.message,
        placement: "topRight",
      });
    }
  };
 
 
  return (
    <Layout>
 
      <div className="flex-1 p-6 background-light min-h-screen pt-30">
 
        {/* Page Heading */}
        <h1 className="text-2xl text-primary font-bold ml-0">Offboarding </h1>
 
        {/* Button */}
        <div className="flex justify-end mb-4">
          <Button
            type="primary"
            icon={<PlusOutlined />}
 
            onClick={() => {
              setSelectedRecord(null); // Clear selected record before opening modal
              setVisible(true);
            }}
            className="text-white border p-4 bg-[var(--color-primary)]"
          >
            Add Item
          </Button>
        </div>
 
 
        {/* Create/Edit Form Modal */}
        {visible && (
          <CreateEditForm
            visible={visible}
            setVisible={setVisible}
            onCreate={onCreate}
            onUpdate={onUpdate}
            selectedRecord={selectedRecord}
          />
        )}
 
        {/* Table Component with List View Functionality */}
        <ListView data={filteredData} onDelete={onDelete} onView={handleView} onEdit={onEdit} onDownload={onDownload} /> {/* Pass data to ListView */}
 
        {/* View Form Modal */}
        <ViewForm
          visible={isViewModalVisible}
          onClose={() => setIsViewModalVisible(false)}
          selectedRecord={selectedRecord}
        />
      </div>
 
    </Layout>
  );
};
 
export default Offboarding;